const BASE_API_URL = `${process.env.REACT_APP_API_URL || '/api'}`;
const router = "";

/**
 * Public marketing site routes. Anything a signed-out visitor can hit
 * from the homepage nav, footer, or CTAs lives here so URL changes only
 * touch one file.
 */
export const HomeRoutes = {
  pageRoutes: Object.freeze({
    HOME: `/`,
    FOUNDER_NOTE: `/founder-note`,
    REPORT: `/report`,
  }),
};

export const AuthRoutes = {
  apiRoutes: Object.freeze({
    GET_AUTH: `${router}/auth`, // Get user's auth status
    POST_SIGNOUT: `${router}/auth/signout`, // Sign out user
    POST_SIGNIN: `${router}/auth/signin`, // Sign in user
    UPDATE: `${router}/auth/update`, // Update user's profile
  }),
  pageRoutes: Object.freeze({
    SIGNIN: `/signin`, // Sign in user
  }),
};

/**
 * Post-auth app routes. The teacher-facing dashboard, lesson planner, and
 * companion pages a signed-in user navigates between. Also serves the
 * companion API routes for the AI chat / lesson-plan endpoints.
 */
export const MaestroRoutes = {
  apiRoutes: Object.freeze({
    CHAT: `${router}/maestro/chat`, // Maestro AI teaching assistant chat
    LESSON_PLAN: `${router}/maestro/lesson-plan/:unitDay`, // Generate lesson plan for specific unit day
    LESSON_PLAN_CUSTOMIZE: `${router}/maestro/lesson-plan/:unitDay/customize`, // Customize lesson plan
    LESSON_RESOURCES: `${router}/maestro/lesson-resources`, // Get AI-curated resources for lesson
  }),
  pageRoutes: Object.freeze({
    DASHBOARD: `/dashboard`,
    DASHBOARD_LEGACY: `/maestro`, // Legacy alias for /dashboard
    LESSON_PLAN: `/lesson-plan/:unitDay`,
    COMMUNITY: `/community`,
    RESOURCES: `/resources`,
  }),
};

export const PrivacyRoutes = {
  pageRoutes: Object.freeze({
    PRIVACY: `/privacy`, // Privacy policy
  }),
};

export const WaitlistRoutes = {
  apiRoutes: Object.freeze({
    SUBMIT: `${router}/waitlist/submit`, // Submit /waitlist form to backend, appended to Google Sheet
  }),
  pageRoutes: Object.freeze({
    WAITLIST: `/waitlist`, // Standalone Join the waitlist page
  }),
};

export const TermsRoutes = {
  pageRoutes: Object.freeze({
    TERMS: `/terms`, // Terms of service
  }),
};

const routesEndpoints = {
  home: HomeRoutes,
  auth: AuthRoutes,
  maestro: MaestroRoutes,
  privacy: PrivacyRoutes,
  terms: TermsRoutes,
  waitlist: WaitlistRoutes,
};

// Generate a url with params object
export const generateParamUrl = (endpoint, params = {}) => {
  const url = Object.keys(params).reduce((prev, current) => {
    return prev.replace(new RegExp(`:${current}[?]?`, "g"), params[current]);
  }, endpoint);
  return url || endpoint;
};

// Get a page route
export const getPageRoute = (module, endpoint, params, queryParams = {}) => {
  const endpointUrl = routesEndpoints?.[module]?.pageRoutes?.[endpoint];
  let stringfiedParams = new URLSearchParams(queryParams).toString();
  if (stringfiedParams) stringfiedParams = `?${stringfiedParams}`;
  return `${generateParamUrl(endpointUrl, params)}${stringfiedParams}`;
};

// Get an api route
export const getApiRoute = (module, endpoint, params, queryParams = {}) => {
  const endpointUrl = routesEndpoints?.[module]?.apiRoutes?.[endpoint];
  let stringfiedParams = new URLSearchParams(queryParams).toString();
  if (stringfiedParams) stringfiedParams = `?${stringfiedParams}`;
  return `${BASE_API_URL}${generateParamUrl(
    endpointUrl,
    params
  )}${stringfiedParams}`;
};
